'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/uid.js
// module id = 180
// module chunks = 13